import { FC, useContext } from 'react';

import { useChatik } from '@hh.ru/chatik-integration';
import VSpacing from 'bloko/blocks/vSpacing';

import ChatikSpoiler from 'src/components/ChatikSpoiler';
import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';

import { useTopicState } from 'src/components/ResumeCard/Actions/Chatik/hooks/useTopicState';

const ChatikContainer: FC = () => {
    const topicState = useTopicState();
    const chatId = topicState?.chatId;
    const { messagesToggle } = useContext(ResumeCardActionsContext);

    const { openChatik } = useChatik();

    const [showMessages] = messagesToggle;
    if (!chatId || !showMessages) {
        return null;
    }

    return (
        <>
            <VSpacing base={4} />
            <ChatikSpoiler chatId={chatId} openChatik={openChatik} />
        </>
    );
};

export default ChatikContainer;
